module.exports = require("remark");


//////////////////
// WEBPACK FOOTER
// external "remark"
// module id = 51
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13